<template>
  <zen-one
    :showuserinfo="false"
    :crumbs="crumbs"
    title="Sistem Hasil Bersepadu Kedah (iHasil)"
  >
            <z-page title="Daftar : Mel">

                <div class="message-box">
                <w-transition-fade>
                    <w-alert
                    class="my0 text-light"
                    v-if="form.submitted"
                    success
                    no-border>
                    The form is valid, ready to send it!
                    </w-alert>

                    <w-alert
                    class="my0 text-light"
                    v-else-if="form.valid === false"
                    error
                    no-border>
                    Terdapat {{ form.errorsCount }} ralat di dalam borang ini.
                    </w-alert>
                </w-transition-fade>
                </div>

                <w-dialog v-model="dialog.show" :fullscreen="dialog.fullscreen" :width="dialog.width" :persistent="dialog.persistent" :persistent-no-animation="dialog.persistentNoAnimation" title-class="primary-light1--bg white">
                    <template #title>
                        Tambah Profil
                    </template>
                    <template #default>
                        <w-form ref="form" v-model="dialog.valid" @validate="submitProfil" @success="success">
                            <template ></template><br>
                            <w-flex justify-space-between class="mb4">
                                <z-input
                                label="No. ID (Kad Pengenalan / No Tentera / No Daftar Syarikat)    *"
                                name="No. ID"
                                v-model="form_profil.no_id"
                                :validators="[validators.required]"/>
                            </w-flex>
                            <w-flex justify-space-between class="mb4">
                                <z-input
                                label="Nama *"
                                name="Nama"
                                v-model="form_profil.nama"
                                :validators="[validators.required]"/>
                            </w-flex>
                            <w-flex justify-space-between class="mb4">
                                <z-input
                                label="Alamat   *"
                                name="Alamat"
                                v-model="form_profil.alamat1"
                                :validators="[validators.required]"/>
                            </w-flex><br>
                            <z-lookup
                                label="Poskod   *"
                                name="poskod"
                                :url='service_utiliti+"lookup/lkp_poskod"'
                                :sort="false" :cache="false"
                                v-model="form_profil.lkp_poskod_id"/><br>
                                <w-flex justify-center align-center>
                                <div class="xs6">
                                    <tr >
                                        <td class="fw-semibold m0">Bandar : &nbsp;&nbsp;&nbsp;</td>
                                        <td>{{form_profil.bandar}}</td>
                                    </tr>
                                </div>
                                <div class="xs6">
                                    <tr >
                                        <td class="fw-semibold m0">Negeri :&nbsp;&nbsp;&nbsp;</td>
                                        <td>{{form_profil.negeri}}</td>
                                    </tr>
                                </div>
                                </w-flex><br>
                            <w-flex justify-space-between class="mb4">
                                <z-input
                                label="No. Telefon  *"
                                name="No. Telefon"
                                v-model="form_profil.no_tel"
                                :validators="[validators.required]"/>
                            </w-flex>
                            <w-flex justify-space-between class="mb4">
                                <z-input
                                label="Email    *"
                                name="Email"
                                v-model="form_profil.emel"
                                :validators="[validators.required, validators.email]"/>
                            </w-flex>
                        </w-form>
                    </template>
                    <template #actions>
                    <div class="spacer" />
                        <w-button bg-color="grey-light5--bg" @click="dialog.show = false">Tutup</w-button>
                        <w-button class="ml1" :loading="dialog.loading" :disabled="dialog.valid === false" @click="$refs.form.validate()">Simpan</w-button>
                    </template>
                </w-dialog>

                <w-card bg-color="" class="">
                    <h3>Butiran Pembayar</h3><br><br>
                        <w-flex class="mt3">
                            <div class="xs11">
                                <z-lookup
                                label="Profil *"
                                name="Profil"
                                placeholder="Carian Profil"
                                :url='kong+"/api/v1/profil"'
                                :sort="false" :cache="false"
                                v-model="form_cari.id"/>
                            </div>
                            <div class="xs1">
                                <w-icon>fal fa-search</w-icon>
                                &nbsp;
                                <w-icon  @click="dialog.show = true">fal fa-plus</w-icon>
                            </div>
                        </w-flex>
                        <br><br>

                        <w-flex justify-center align-center>
                            <div class="xs6">
                            <h5 class="fw-semibold m0">
                                Profil :
                            </h5><br>
                            {{form.no_id}}  {{form.nama}}
                            </div>

                            <div class="xs6">
                            <h5 class="fw-semibold m0">
                                    Alamat :
                                </h5><br>
                                {{form.alamat1}}  {{form.poskod}} {{form.bandar}} {{form.negeri}}
                            </div>
                        </w-flex><br><br>
                </w-card><br>
            </z-page>
        <!-- <template v-if=""> -->
        <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="submitTerimaanPukal" @success="onSuccess">
            <z-page title="Butiran Bayaran" >
                  <w-card bg-color="" class="">
                    <w-flex justify-space-between class="mb4">
                        <div class="xs4">
                            <w-input label="No Rujukan" v-model="form_cari.no_rujukan" name="no_rujukan" />
                        </div>
                        <div class="xs4">
                            <w-button class="ml1 " @click="Detail()">
                                <w-icon>fal fa-search</w-icon>&nbsp;Cari
                            </w-button>
                        </div>
                    </w-flex>
                  </w-card>
                  <w-flex justify-center align-center class="table-hardcode mt3">
                     <div class="w-card__content content-hardcode">
                        <table class="table-dashboard" width="100%">
                            <thead>
                                <tr>
                                    <td>Jabatan</td>
                                    <td>No. Rujukan</td>
                                    <td>Kod Akaun</td>
                                    <td>Butiran Bayaran</td>
                                    <td>Amaun (RM)</td>
                                    <td>Amaun Bayar (RM)</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="dat, index in form.hm_cukai">
                                    <td>
                                      {{dat.jabatan}}
                                    </td>
                                    <td>
                                      {{dat.no_hm}}
                                    </td>
                                    <td>
                                      {{dat.kod_akaun}}
                                    </td>
                                    <td>
                                      {{dat.akaun_keterangan}}
                                    </td>
                                    <td>
                                      {{dat.amaun_debit}}
                                    </td>
                                    <td>
                                        <w-input class="mb4" label="" type="number" v-model="dat.amaun_bayaran" v-on:keyup="cekAmaunBayaran(dt)" v-on:click="cekAmaunBayaran(dt)" />
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="5" align="right">JUMLAH</td>
                                    <td align="right">{{form.amaun_bayaran}}</td>
                                    <!-- <td align="center"></td> -->
                                </tr>
                            </tbody>
                        </table>
                        <w-flex class="mt3" wrap align-center justify-end>
                            <div class="spacer" />
                            <w-button class="my1" type="submit" :disabled="form.valid === false" :loading="form.submitted && !form.sent">
                                <w-icon dark tile class="mr2">fal fa-save</w-icon> Simpan
                            </w-button>
                        </w-flex>
                      </div>
                  </w-flex>
            </z-page>
        </w-form>
        <!-- </template> -->

  </zen-one>
</template>

<script>

import ZResource from '@/Modules/z-resource-service'


export default {
  extends: ZResource,
  components: {

  },
  props: {
    id: [Array, Object, String],
  },
  data() {
    return {

    resourceurl: this.service_kutipan+'terimaan',
    reload: true,
    form_profil :{},
    form_cari : {},
      crumbs: [
            { label: 'iHasil', route: '/ihasil' },
            { label: 'Mel', route: 'kutipan/mel' },
            { label: 'Daftar ', route: 'kutipan/mel/daftar' }
      ],

    validators: {
          required: value => !!value || 'Medan Ini Wajib',
          email: value => !!value.match(/\w+\.?\w+@\w+(\.\w+)+/i) || 'Sila semak format email',

        },

    }
  },
    methods: {

        profilDetail() {

        this.$zcomm.get(this.service_kutipan+'profil/'+this.form_cari.id).then(res => {
                this.form.profil_id = res.id;
                this.form.no_id = res.no_id;
                this.form.nama = res.nama;
                this.form.alamat1 = res.alamat1;
                this.form.poskod = res.poskod;
                this.form.bandar = res.bandar;
                this.form.negeri = res.negeri;

                });
        },

        poskodDetail() {

        this.$zcomm.get(this.service_utiliti+'lookup/lkp_poskod_detail/'+this.form_profil.lkp_poskod_id).then(res => {
                this.form_profil.negeri = res.negeri;
                this.form_profil.lkp_negeri_id = res.lkp_negeri_id;
                this.form_profil.bandar = res.bandar;
                this.form_profil.lkp_jenis_alamat_id = 1;
                });
        },

        submitProfil() {
            // if (this.$refs.form.validate()) {
                this.dialog.loading = true


                    this.$zcomm.post(this.service_kutipan+'profil' , this.form_profil)
                        .then(res => {
                          // console.log(res)
                          //update displayed record
                          // this.$page.flash.success = "Rekod telah ditambah"
                          this.mapreturneddata(res)
                          this.dialog.show = false;
                          if (typeof this.onAfterAdd === "function") {
                            this.onAfterAdd()
                          }
                          this.form.profil_id = res.id;
                          this.form.no_id = res.no_id;
                          this.form.nama = res.nama;
                          this.form.alamat1 = res.alamat1;
                          this.form.poskod = res.poskod;
                          this.form.bandar = res.bandar;
                          this.form.negeri = res.negeri;
                            // this.$inertia.visit(this.$page.url)

                        })
                        .finally(() => {
                            this.dialog.loading = false;
                            this.dialog.show = false;

                          // $('#' + this.resourceurl).modal('hide')
                        });

            // }
        },

        cekAmaunBayaran(){
          this.form.amaun_bayaran = 0;
          for (var i in this.form.hm_cukai) {
            this.form.amaun_bayaran = this.form.amaun_bayaran + parseFloat(this.form.hm_cukai[i].amaun_bayaran);
            }
        },


        Detail() {
            this.$zcomm.get(this.service_kutipan+'terimaan'+'?no_rujukan='+this.form_cari.no_rujukan).then(res => {
            //   console.log(res.data)
              if (res.data.butiran) {
                  this.form.inbois_id = res.data.id;
                  this.form.butiran = res.data.butiran;
                  this.form.amaun = res.data.amaun;
                  this.form.no_inbois = res.data.no_inbois;
                  this.form.jabatan_id = res.data.jabatan.id;
              }else{
                  this.form.hm_akaun_id = res.data.id;
                  this.form.hm_cukai = res.data.hm_cukai;
                  this.form.keluasan = res.data.keluasan;
                  this.form.no_hm = res.data.no_hm;
                  this.form.jabatan_id = res.data.jabatan.id;
              }

            });

        },

        submitTerimaanPukal(){
        // alert('asssd');
        this.form.profil_id = this.form_cari.id
        // this.form.amaun_bayar = this.form.hm_cukai.amaun_bayar
        this.$zcomm.post(this.service_kutipan+'terimaan_pukal', this.form)
          .then(res => {
                          if (typeof this.onAfterAdd === "function") {
                              this.onAfterAdd()
                          }

                        })
                        .catch(err => {

                        })
                        .finally(() => {
                                this.$inertia.visit(window.route('kutipan.mel.index'));
                        })
                        ;
        },



        // reset(){
        //       this.cari = {no_rujukan: ''}
        //       this.search()
        // },

  },
  watch: {

        'form_profil.lkp_poskod_id': function(q) {

                this.poskodDetail();

        },

        'form_cari.id': function(q) {

                this.profilDetail();

        },

  },
  mounted() {
    this.dialog.width = 900

  },

}
</script>
